export const handleCardDisplay = (cardNumber) => {
  const rawText = [...cardNumber.split(" ").join("")]; // Remove old space
  const creditCard = []; // Create card as array
  rawText.forEach((t, i) => {
    if (i % 4 === 0 && i !== 0) creditCard?.push(" "); // Add space
    creditCard.push(t);
  });
  return creditCard?.join(""); // Transform card array to string
};